function hasImageUrl(item) {
  return typeof item?.img_url === 'string' && item.img_url.trim() !== '';
}

function hasSameId(left, right) {
  return left != null && right != null && String(left) === String(right);
}

function normalizeWord(word) {
  if (!word || /^\d+(?:[.,]\d+)?$/.test(word) || word === 'мм' || word === 'стекло') {
    return null;
  }
  if (word.startsWith('тонир')) return 'тонир';
  return word.replace(/(ого|его|ому|ему|ыми|ими|ую|юю|ая|яя|ое|ее|ые|ие|ый|ий|ой)$/u, '');
}

function normalizeNameTokens(value) {
  return String(value || '')
    .toLocaleLowerCase('ru-RU')
    .replace(/ё/g, 'е')
    .replace(/[^a-zа-я0-9]+/giu, ' ')
    .trim()
    .split(/\s+/)
    .map(normalizeWord)
    .filter(Boolean);
}

function tagMatchesSelection(tagName, selectionName) {
  const tagTokens = normalizeNameTokens(tagName);
  const selectionTokens = normalizeNameTokens(selectionName);
  if (!tagTokens.length || !selectionTokens.length) return false;
  if (tagTokens.join(' ') === selectionTokens.join(' ')) return true;
  return tagTokens.length > 1 && tagTokens.every((token) => selectionTokens.includes(token));
}

function normalizeGroupName(tag) {
  return String(tag?.tag_group || tag?.group_name || '').trim().toLocaleLowerCase('ru-RU');
}

export function photoMatchesConfiguration(photo, { glassTypeName, hardwareSetName }) {
  if (!glassTypeName || !hardwareSetName) return false;
  const tags = Array.isArray(photo?.tags) ? photo.tags : [];
  const hasGlassTag = tags.some(
    (tag) => normalizeGroupName(tag) === 'тип стекла' && tagMatchesSelection(tag.name, glassTypeName),
  );
  const hasHardwareTag = tags.some(
    (tag) => normalizeGroupName(tag) === 'фурнитура' && tagMatchesSelection(tag.name, hardwareSetName),
  );
  return hasGlassTag && hasHardwareTag;
}

export function buildProductImageGallery({
  defaultImageUrl,
  variantRenders = [],
  photos = [],
  glassTypeId,
  hardwareSetId,
  glassTypeName,
  hardwareSetName,
}) {
  const primaryRender = variantRenders.find(
    (render) =>
      render?.is_primary === true &&
      hasImageUrl(render) &&
      hasSameId(render.glass_type_id, glassTypeId) &&
      hasSameId(render.hardware_set_id, hardwareSetId),
  );

  const images = [];
  if (primaryRender) {
    images.push({ ...primaryRender, type: 'render' });
  } else if (typeof defaultImageUrl === 'string' && defaultImageUrl.trim() !== '') {
    images.push({ img_url: defaultImageUrl, type: 'default' });
  }

  photos.forEach((photo) => {
    if (hasImageUrl(photo) && photoMatchesConfiguration(photo, { glassTypeName, hardwareSetName })) {
      images.push({ ...photo, type: 'photo' });
    }
  });

  return images;
}
